import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Quiz from "./pages/Quiz";
import Success from "./pages/Success";
import Privacy from "./pages/Privacy";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/quiz" replace />} />
      <Route path="/quiz" element={<Quiz />} />
      <Route path="/success" element={<Success />} />
      <Route path="/privacidade" element={<Privacy />} />
      <Route path="*" element={<Navigate to="/quiz" replace />} />
    </Routes>
  );
}
